import React from "react";
import { Input } from "antd";
import type { TextAreaProps } from "antd/es/input/TextArea";
import { FileText } from "lucide-react";
import styled from "styled-components";

const Wrapper = styled.div`
	position: relative;
`;

const StyledTextArea = styled(Input.TextArea)`
	&&& {
		padding-bottom: 40px !important;
		resize: none;
	}
`;

const CharacterCount = styled.div`
	position: absolute;
	right: 20px;
	bottom: 8px;
	z-index: 10;
	display: flex;
	align-items: center;
	gap: 6px;
	color: #9b9b9b;
	font-size: 12px;
	pointer-events: none;
`;

export const CharacterCountTextArea: React.FC<TextAreaProps> = ({ value, maxLength, ...props }) => {
	const characterCount = typeof value === "string" ? value.length : String(value ?? "").length;

	return (
		<Wrapper>
			<StyledTextArea {...props} value={value} maxLength={maxLength} />
			{typeof maxLength === "number" && (
				<CharacterCount>
					<FileText size={14} />
					{characterCount}/{maxLength}
				</CharacterCount>
			)}
		</Wrapper>
	);
};
